import type { AuthState, Recipient } from '@/types'

export const buildRecipient = (auth: AuthState): Recipient | null => {
  if (!auth.authenticated) {
    return null
  }

  return {
    ...auth,
    pending: false,
  }
}
